import styles from "./Card.module.css";

const Card = (props) => {
  let colorClass = "";

  if (props.color === "dark") {
    colorClass = styles.blue;
  }
  if (props.color === "alt") {
    colorClass = styles.alt;
  }
  if (!props.color) {
    colorClass = styles.white;
  }

  return <div className={`${styles.card} ${colorClass}`}>{props.children}</div>;
};

export default Card;
